<div  *ngIf="!loading">
  <div class="edit" *ngIf="editPortal && !isModel">
  <div class="edit_title">
    <span>{{ editTitle }}</span>
    <span>{{ editId }}</span>
  </div>

  <div class="sku-panel_devider"></div>

  <ng-template
    [cdkPortalOutlet]="editPortal"
    (attached)="attachEditPortal($event)"
  ></ng-template>
</div>

<div class="sku-panel" *ngIf="selectedSku && !editPortal && this.selectedRow?.length == 1">
  <div class="sku-panel_title">
    SKU Details
  </div>

  <div class="sku-panel_devider"></div>

  <app-sku-info [sku]="selectedSku" [isPriceyardSmallSidePanel]="selectedPortal?.component.name === 'PriceyardPanelComponent'" [isModel]="isModel"  ></app-sku-info>
  <div class="indicator-tags d-flex align-items-baseline flex-nowrap">
    <label for="" class="input-container_label mb-0 mr-2">Tags:</label>
     <div class="d-flex flex-wrap gap-1">
      <span *ngFor="let tag of skuTagsDto" class="indicator-tags_tags" [matTooltip]="tag.name" [style.backgroundColor]="tag?.colorCode" > 
        {{tag.name}} <span class="tagDelete" (click)="deleteTag(tag.tagId)">
          <i class="fal fa-times-circle"></i>
        </span></span>
      <span class="indicator-tags_addTags" (click)="openAllTag($event)">
        <i class="fal fa-plus hand"></i>
      </span>
     </div>
  </div>
  <div class="sku-panel_devider" *ngIf="selectedPortal?.component.name !== 'ShipyardPanelComponent'"></div>

  <ng-container *ngIf="!isModel">
    <ng-template
      [cdkPortalOutlet]="selectedPortal"
      (attached)="attach($event)"
    ></ng-template>
  </ng-container>
</div>
<div class="no-result" *ngIf="!this.selectedRow?.length">
  <app-no-results [message]="'No row selected'"></app-no-results>
</div>
</div>
<div class="no-result" *ngIf="loading">
  <app-no-results [message]="'Loading Sku Details'"></app-no-results>
</div>